export const TituloConfirmacaoExclusao = 'Deseja Excluir?'
export const MensagemConfirmacaoExclusao = 'O registro será excluído permanentemente.'
export const TituloShouldNavigate = 'Deseja Continuar?'
export const MensagemShouldNavigate = 'As informações que não foram salvas serão perdidas.'
export const MensagemSuccessSave = 'Registro salvo com Sucesso.'